import { UserProfile } from '$logic/profile/storage'
import { isNumber } from '$func/utils'

export const isMadreseTaaliProfileCompleted = (profile: UserProfile) => {
  return isNumber(profile?.extra?.networks?.[0])
}
